/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CheckCircleFilledIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M20.023 32c-4.312 0-8.25-2.25-10.406-6-2.156-3.703-2.156-8.25 0-12 2.156-3.703 6.094-6 10.406-6 4.266 0 8.204 2.297 10.36 6 2.156 3.75 2.156 8.297 0 12a11.91 11.91 0 0 1-10.36 6m5.297-14.203h-.047c.47-.422.47-1.125 0-1.594a1.103 1.103 0 0 0-1.546 0l-5.204 5.25-2.203-2.203c-.468-.469-1.172-.469-1.593 0a1.027 1.027 0 0 0 0 1.547l3 3c.421.469 1.125.469 1.593 0z"/>}
        </IconWrapper>);
}
